// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2lAMc","empty":"ModalGraph_empty__1cKqR"};